import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import storage from '@/core/storage'
import {
    DatetimePicker,
    Popup,
    Checkbox,
    CheckboxGroup,
    Button,
    Dialog,
    Uploader,
    Tab,
    Tabs,
    Form,
    Field,
    Picker,
    Cell,
    CellGroup,
    Loading,
    Sticky,
    Icon,
    Image as VanImage,
    RadioGroup,
    Radio,
    NoticeBar,
    Collapse,
    CollapseItem,
    Calendar
} from 'vant'

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$storage = storage
Vue.use(DatetimePicker)
    .use(Popup)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Button)
    .use(Dialog)
    .use(Uploader)
    .use(Tab)
    .use(Tabs)
    .use(Form)
    .use(Field)
    .use(Picker)
    .use(Cell)
    .use(CellGroup)
    .use(Loading)
    .use(Sticky)
    .use(Icon)
    .use(VanImage)
    .use(Radio)
    .use(RadioGroup)
    .use(NoticeBar)
    .use(Collapse)
    .use(CollapseItem)
    .use(Calendar)

new Vue({
    router,
    render: (h) => h(App)
}).$mount('#app')
